export { default } from './SearchSectionRugs';
